import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Box } from 'grommet/components/Box';
import { Text } from 'grommet/components/Text';
import { Button } from 'grommet/components/Button';
import AccessibleSelect from '../Components/AccessibleSelect';
import ReactTable from "react-table";
import Pagination from './../Components/Pagination';
import ReactExport from "react-data-export";
import { DisputeCtrl } from '../Controllers/Disputes/DisputeCtrl';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
import { loader, noData, formatAmount } from '../Utils/Utility';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
class AddebitiAccrediti extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {
            dataTable: [],
            datas: [],
            search: '',
            checked: 'CBP',
            selectedMonthYear: '',
            selectedMonthYearLabel: '',
            selected: {},
            showresult: false,
            value: [],
            months: [],
            showTimeoutModal: false,
            loadingExcel: false,
            status: '',
            isRicerca: false,
            firstTimeMount: false
        }

        this.setSelectionMonthYear = this.setSelectionMonthYear.bind(this);
        //this.prevPage = this.prevPage.bind(this);
        //this.nextPage = this.nextPage.bind(this);
        this.showResult = this.showResult.bind(this);
        this.downloadExcel = this.downloadExcel.bind(this);
    }

    componentDidMount() {

        var date = new Date();
        var months = []
        var numericMonths = [],
            monthNames = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

        for (var i = 0; i < 13; i++) {
            var calMonth = 1 + date.getMonth()
            var tempMonth = calMonth < 10 ? '0' + calMonth : calMonth


            months.push(monthNames[date.getMonth()] + ' ' + date.getFullYear());
            numericMonths.push(date.getFullYear() + '' + tempMonth);
            date.setMonth(date.getMonth() - 1);

        }
        //console.log(months)
        return this.setState({ months, numericMonths })

    }

    setSelectionMonthYear(event) {
        // Estrae il valore dall'oggetto dell'opzione selezionata
        const selectedValue = event.option ? event.option.value : '';
        const selectedIndex = this.state.months.findIndex(month => month === selectedValue);
        var val = selectedIndex >= 0 ? this.state.numericMonths[selectedIndex] : '';
        
        this.setState({
            selectedMonthYearLabel: selectedValue,
            selectedMonthYear: val
        })
    }


    showResult(typeCall) {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;

        this.setState({
            firstTimeMount: true,
            isRicerca: true,
            dataTable: []
        },()=>{
            DisputeCtrl(function (data) {
                self.setState({
                    dataTable: data === '' ? [] : data.disputeList,
                    isRicerca: false
                });
            }, function (error) {
                self.setState({
                    status: error
                }, function () {
                    if (this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403) {
                        this.props.history.push({
                            pathname: '/ErrorPage',
                            state: this.state
                        })
                    } else if (this.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                        // logout();
                        // this.props.history.push({
                        //     pathname: '/login'
                        // })
                    }
                })

            }, this.state, typeCall, token, ids);
        });
    }

    downloadExcel(typeCall) {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;
        const {history} = this.props;
        this.setState({
          loadingExcel: true
        })
        DisputeCtrl(function (data) {
            self.setState({
              datas: data === '' ? [] : data.disputeList,
              loadingExcel: false
            });
            document.getElementById('excel').click();
          }, function (error) {
                if(error === 401 || error === 408){
                    self.setState({
                        showTimeoutModal: true
                    })
                } else {
                    history.push('/ErrorPage');
                }
            }, this.state, typeCall, token, ids);
      }

    // prevPage(){
    //     let cp = this.state.currentPage;
    //     if (cp === 1) return;
    //     this.setState({
    //       currentPage: cp - 1
    //     },() => {
    //       this.showResult();
    //     });
    // }
    
    // nextPage(){
    //     let cp = this.state.currentPage;
    //     if (cp === this.state.pages) return;
    //     this.setState({
    //         currentPage: cp + 1
    //     },() => {
    //         this.showResult();
    //     });
    // }



    render() {

        const columns = [

            {
                Header: 'CODICE ESERCIZIO',
                accessor: 'branchCode',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'DATA LETTERA',
                accessor: 'dataLettera',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'DESCRIZIONE',
                accessor: 'descTipoDispute',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'IMPORTO NETTO',
                accessor: 'importoDisputa',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => formatAmount(row.original.importoDisputa)
            },
            {
                Header: 'NUMERO PRATICA',
                accessor: 'numeroPratica',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            }


        ]

        const hasData = (Array.isArray(this.state.dataTable) && this.state.dataTable.length > 0 && this.state.dataTable !== null && this.state.dataTable !== undefined)

        return (
            <Box>

                <Box align='center' className='content addebiti-page' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }}>
                    {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                    <Box className='contentbox'>
                        <Box pad='medium' align='start' style={{ paddingBottom: '50px' }}>
                            <Text className='titlehome'><h1>Consulta Addebiti/Accrediti Generati da Contestazioni </h1></Text>
                            <Text className='subtitlehome'><h3>Seleziona i filtri di ricerca</h3></Text>
                        </Box>

                        <Box align='center' id='searchpv' justify='center'>
                            <Text className='titlesectionhome' id='periodo-temporale-section'><h3>PERIODO TEMPORALE</h3></Text>

                            <Box className='genericext' direction='row' gap='small' style={{ marginTop: '30px' }}>
                                <Box>
                                    <Text className='label' htmlFor='year' id='year-label' aria-hidden="false"><h5>MESE E ANNO*</h5></Text>
                                    <AccessibleSelect
                                        id='year'
                                        className='select'
                                        placeholder='Seleziona Mese'
                                        options={this.state.months.map(month => ({
                                            label: month,
                                            value: month,
                                            'aria-label': month
                                        }))}
                                        labelKey='label'
                                        valueKey='value'
                                        value={this.state.selectedMonthYearLabel ? {
                                            label: this.state.selectedMonthYearLabel,
                                            value: this.state.selectedMonthYearLabel,
                                            'aria-label': this.state.selectedMonthYearLabel
                                        } : ''}
                                        onChange={this.setSelectionMonthYear}
                                        aria-labelledby='year-label periodo-temporale-section'
                                        aria-required='true'
                                        a11yTitle='Mese e anno'
                                        dropAlign={{ top: 'bottom' }}
                                        dropProps={{
                                            a11yTitle: 'Opzioni di mese e anno disponibili',
                                            role: 'listbox',
                                            'aria-multiselectable': 'false'
                                        }}
                                        messages={{
                                            multiple: 'Selezionato',
                                            selected: 'Selezionato'
                                        }}
                                    />
                                </Box>
                            </Box>
                            <Box style={{ width: '200px', marginTop: '20px' }}>
                                <Text className='suggestion  CO'><h5>*Campi obbligatori</h5></Text>
                            </Box>
                            <Box style={{ margin: '40px 0 20px' }}>
                                <Button 
                                    className={!this.state.selectedMonthYearLabel ? 'btnsearchForm disabled' : 'btnsearchForm'} 
                                    onClick={() => this.showResult()} 
                                    disabled={!this.state.selectedMonthYearLabel}
                                    aria-label="Cerca addebiti e accrediti generati da contestazioni"
                                    role="button"
                                >
                                    <i className='icon-magnifying-glass' aria-hidden="true" style={{ fontSize: '20px', fontStyle: 'normal' }} /> CERCA
                                </Button>
                            </Box>
                        </Box>

                        <Box direction='row' style={{ padding: '0 2%' }}>
                            <Box pad='large' style={{ width: '100%', padding: '0' }}>
                                {this.state.firstTimeMount ?
                                    hasData ?
                                        <div> 
                                            <ReactTable
                                            PaginationComponent={Pagination}
                                            data={this.state.dataTable}
                                            columns={columns}
                                            sortable={true}
                                            multiSort={true}
                                            resizable={true}
                                            showPagination={false}
                                            loading={false}
                                            defaultPageSize={this.state.dataTable.length}
                                            style={{ paddingBottom: '20px' }} />

                                            {this.state.loadingExcel ? 

                                                <Box style={{textAlign: "left"}}>   
                                                    {loader}
                                                </Box>
            
                                                :
                                                
                                                <Box className='contentXsls'>
                                                    <Box direction='row' className='excel' onClick={() => this.downloadExcel("C")}>
                                                        <Text className='export'>ESPORTA
                                                        <button type="button" aria-label="Esporta in Excel" style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer', marginLeft: '10px', verticalAlign: 'middle' }}>
  <i className='icon-xlsx-file-format-extension' aria-hidden="true" style={{ fontSize: '20px' }} />
</button>
                                                        </Text>
                                                    </Box>
                                                    <ExcelFile filename='AddebitiAccrediti' element={<span style={{margin:'0'}} id='excel'/>}>
                                                        <ExcelSheet data={this.state.datas} name="AddebitiAccrediti">
                                                            <ExcelColumn label="CODICE ESERCIZIO" value="branchCode" />
                                                            <ExcelColumn label="DATA LETTERA" value="dataLettera" />
                                                            <ExcelColumn label="DESCRIZIONE" value="descTipoDispute" />
                                                            <ExcelColumn label="IMPORTO NETTO" value="importoDisputa" />
                                                            <ExcelColumn label="NUMERO PRATICA" value="numeroPratica" />
                                                        </ExcelSheet>
                                                    </ExcelFile>
                                                </Box>
                                            }
                                        </div>
                                        : this.state.isRicerca ?
                                            loader

                                        : noData
                                : null}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        )
    }
}
export default AddebitiAccrediti;